module.exports = __webpack_public_path__ + "static/media/CHAP04-CITATION2.7217ee3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StaticElement/img/CHAP04-CITATION2.png
// module id = 306
// module chunks = 0